import { render } from "./SlideDataFormColors.vue?vue&type=template&id=431211c0"
import script from "./SlideDataFormColors.vue?vue&type=script&lang=js"
export * from "./SlideDataFormColors.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__